import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationDialogData } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-decline-trainer-invitation-dialog',
  standalone: false,
  templateUrl: './decline-trainer-invitation-dialog.component.html',
  styleUrl: './decline-trainer-invitation-dialog.component.scss'
})
export class DeclineTrainerInvitationDialogComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() decline = new EventEmitter();

  declineTrainingModalOptions!: ConfirmationDialogData;

  constructor(
    private translateService: TranslateService
  ) {

  }

  ngOnInit() {
    this.declineTrainingModalOptions = {
      title: this.translateService.instant(
        'TRAINER-DETAILS.DECLINE-INVITATION-DIALOG.TITLE'
      ),
      message: this.translateService.instant(
        'TRAINER-DETAILS.DECLINE-INVITATION-DIALOG.TEXT'
      ),
      hideUndo: true,
      submitButtonText: this.translateService.instant('COMMON.YES'),
      dismissButtonText: this.translateService.instant('COMMON.NO'),
    };
  }

  onDecline(){
    this.decline.emit();
  }

  onShowModalChange(showModal: boolean) {
    this.showModal = showModal;
    this.showModalChange.emit(this.showModal);
  }
}
